// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("@assets/HUD/footer_ornament.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("@assets/HUD/skip_btn_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("@assets/game_end/leave_btn_active.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("@assets/HUD/class_icon_frame_w.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("@assets/HUD/class_icon_frame_bm.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("@assets/HUD/class_icon_frame_wm.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("@assets/HUD/blue_box.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("@assets/HUD/red_box.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spectator_footer_wrapper {
  position: fixed;
  bottom: 9vh;
  left: 0;
  right: 0;
  width: 100%;
  height: 64px;
  z-index: 10;
  padding-bottom: 8px;
  pointer-events: none;
}

.spectator_footer_container {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 100% 100%;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: .2s;
  padding-bottom: 12px;
  pointer-events: auto;

  @media screen and (max-width: 1500px) and (orientation: landscape) {
    transform: scale(0.9);
    transform-origin: bottom center;
  }

  @media screen and (max-width: 1400px) and (orientation: landscape) {
    transform: scale(0.75);
  }

  @media screen and (max-width: 1100px) and (orientation: landscape) {
    transform: scale(0.65);
  }

  /* @media screen and (max-width: 980px) and (orientation: landscape) {
    transform: scale(0.55);
  } */
}

.skip_tutorial {
  position: absolute;
  bottom: 0;
  right: 16px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: 100% 100%;
  height: 54px;
  padding: 0 24px 0 16px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  color: #ffffff;
  text-transform: uppercase;
}

.skip_tutorial:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.turn_timeline_wrapper {
  position: relative;
}

.turn_timeline {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  position: relative;
  margin: 0 auto;
}

.timeline_character {
  display: flex;
  align-items: center;
  position: absolute;
  transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  will-change: transform;
  left: 0;
  pointer-events: auto;
}

.timeline_portrait_container {
  width: 60px;
  height: 60px;
  border-radius: 4px;
  background-size: contain;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  transition: transform 0.3s ease;
  margin: 3px;
}

.timeline_character:first-child .timeline_portrait_container {
  transform: scale(1.15);
  box-shadow: 0 0 20px rgba(113, 222, 255, 0.5);
  animation: pulsate 0.5s infinite;
}

.timeline_portrait {
  width: 100%;
  height: 100%;
  background-position: -40px -40px;
  background-repeat: no-repeat;
  transform: scale(0.7);
}

.timeline_character:last-child::before,
.timeline_character:last-child::after {
  display: none;
}

@keyframes pulsate {
  0% {
    box-shadow: 0 0 20px rgba(113, 222, 255, 0.5);
  }
  50% {
    box-shadow: 0 0 30px rgba(113, 222, 255, 0.8);
  }
  100% {
    box-shadow: 0 0 20px rgba(113, 222, 255, 0.5);
  }
}

.turn_order_label {
  font-family: 'Kim', sans-serif;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
  text-transform: uppercase;
  letter-spacing: 2px;
  text-align: center;
  padding: 2px 12px;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(113, 222, 255, 0.1) 20%,
    rgba(113, 222, 255, 0.15) 50%,
    rgba(113, 222, 255, 0.1) 80%,
    transparent
  );
  border-radius: 2px;
  text-shadow: 0 0 10px rgba(113, 222, 255, 0.3);
  position: absolute;
  bottom: -40px;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: 4px;
  white-space: nowrap;
}

.turn_order_label::before,
.turn_order_label::after {
  content: "";
  position: absolute;
  top: 50%;
  width: 15px;
  height: 1px;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(113, 222, 255, 0.4),
    transparent
  );
}

.turn_order_label::before {
  left: -20px;
}

.turn_order_label::after {
  right: -20px;
}

@media screen and (max-width: 1500px) and (orientation: landscape) {
  .turn_order_label {
    font-size: 11px;
  }
}

@media screen and (max-width: 1400px) and (orientation: landscape) {
  .turn_order_label {
    font-size: 10px;
  }
}

.timeline_class_indicator {
  position: absolute;
  top: -10px;
  right: -10px;
  width: 28px;
  height: 28px;
  background-size: contain;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
}

.frame-warrior {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.frame-black-mage {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.frame-white-mage {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

.timeline_class_indicator img {
  width: 50%;
  height: 50%;
  object-fit: contain;
}

.timeline_class_indicator .warrior {
  transform: scaleX(1.5);
}

/* Adjust the portrait container to accommodate the class indicator */
.timeline_portrait_container {
  position: relative;
  margin: 3px;
}

.ally_portrait {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

.enemy_portrait {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}`, "",{"version":3,"sources":["webpack://./src/components/HUD/Timeline.style.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,WAAW;EACX,OAAO;EACP,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,yDAAwD;EACxD,0BAA0B;EAC1B,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,oBAAoB;;EAEpB;IACE,qBAAqB;IACrB,+BAA+B;EACjC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;KAEG;AACL;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,yDAAoD;EACpD,0BAA0B;EAC1B,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yDAA8D;AAChE;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,uDAAuD;EACvD,sBAAsB;EACtB,OAAO;EACP,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,6CAA6C;EAC7C,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE;IACE,6CAA6C;EAC/C;EACA;IACE,6CAA6C;EAC/C;EACA;IACE,6CAA6C;EAC/C;AACF;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,+BAA+B;EAC/B,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB;;;;;;;GAOC;EACD,kBAAkB;EAClB,8CAA8C;EAC9C,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,WAAW;EACX;;;;;GAKC;AACH;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yDAA2D;AAC7D;;AAEA;EACE,yDAA4D;AAC9D;;AAEA;EACE,yDAA4D;AAC9D;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,qEAAqE;AACrE;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,yDAAiD;AACnD;;AAEA;EACE,yDAAgD;AAClD","sourcesContent":[".spectator_footer_wrapper {\n  position: fixed;\n  bottom: 9vh;\n  left: 0;\n  right: 0;\n  width: 100%;\n  height: 64px;\n  z-index: 10;\n  padding-bottom: 8px;\n  pointer-events: none;\n}\n\n.spectator_footer_container {\n  background-image: url(\"@assets/HUD/footer_ornament.png\");\n  background-size: 100% 100%;\n  height: 48px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transition: .2s;\n  padding-bottom: 12px;\n  pointer-events: auto;\n\n  @media screen and (max-width: 1500px) and (orientation: landscape) {\n    transform: scale(0.9);\n    transform-origin: bottom center;\n  }\n\n  @media screen and (max-width: 1400px) and (orientation: landscape) {\n    transform: scale(0.75);\n  }\n\n  @media screen and (max-width: 1100px) and (orientation: landscape) {\n    transform: scale(0.65);\n  }\n\n  /* @media screen and (max-width: 980px) and (orientation: landscape) {\n    transform: scale(0.55);\n  } */\n}\n\n.skip_tutorial {\n  position: absolute;\n  bottom: 0;\n  right: 16px;\n  background-image: url(\"@assets/HUD/skip_btn_bg.png\");\n  background-size: 100% 100%;\n  height: 54px;\n  padding: 0 24px 0 16px;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 12px;\n  color: #ffffff;\n  text-transform: uppercase;\n}\n\n.skip_tutorial:hover {\n  background-image: url(\"@assets/game_end/leave_btn_active.png\");\n}\n\n.turn_timeline_wrapper {\n  position: relative;\n}\n\n.turn_timeline {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 10px;\n  position: relative;\n  margin: 0 auto;\n}\n\n.timeline_character {\n  display: flex;\n  align-items: center;\n  position: absolute;\n  transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);\n  will-change: transform;\n  left: 0;\n  pointer-events: auto;\n}\n\n.timeline_portrait_container {\n  width: 60px;\n  height: 60px;\n  border-radius: 4px;\n  background-size: contain;\n  background-repeat: no-repeat;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  transition: transform 0.3s ease;\n  margin: 3px;\n}\n\n.timeline_character:first-child .timeline_portrait_container {\n  transform: scale(1.15);\n  box-shadow: 0 0 20px rgba(113, 222, 255, 0.5);\n  animation: pulsate 0.5s infinite;\n}\n\n.timeline_portrait {\n  width: 100%;\n  height: 100%;\n  background-position: -40px -40px;\n  background-repeat: no-repeat;\n  transform: scale(0.7);\n}\n\n.timeline_character:last-child::before,\n.timeline_character:last-child::after {\n  display: none;\n}\n\n@keyframes pulsate {\n  0% {\n    box-shadow: 0 0 20px rgba(113, 222, 255, 0.5);\n  }\n  50% {\n    box-shadow: 0 0 30px rgba(113, 222, 255, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 20px rgba(113, 222, 255, 0.5);\n  }\n}\n\n.turn_order_label {\n  font-family: 'Kim', sans-serif;\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.7);\n  text-transform: uppercase;\n  letter-spacing: 2px;\n  text-align: center;\n  padding: 2px 12px;\n  background: linear-gradient(\n    90deg,\n    transparent,\n    rgba(113, 222, 255, 0.1) 20%,\n    rgba(113, 222, 255, 0.15) 50%,\n    rgba(113, 222, 255, 0.1) 80%,\n    transparent\n  );\n  border-radius: 2px;\n  text-shadow: 0 0 10px rgba(113, 222, 255, 0.3);\n  position: absolute;\n  bottom: -40px;\n  left: 50%;\n  transform: translateX(-50%);\n  margin-bottom: 4px;\n  white-space: nowrap;\n}\n\n.turn_order_label::before,\n.turn_order_label::after {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  width: 15px;\n  height: 1px;\n  background: linear-gradient(\n    90deg,\n    transparent,\n    rgba(113, 222, 255, 0.4),\n    transparent\n  );\n}\n\n.turn_order_label::before {\n  left: -20px;\n}\n\n.turn_order_label::after {\n  right: -20px;\n}\n\n@media screen and (max-width: 1500px) and (orientation: landscape) {\n  .turn_order_label {\n    font-size: 11px;\n  }\n}\n\n@media screen and (max-width: 1400px) and (orientation: landscape) {\n  .turn_order_label {\n    font-size: 10px;\n  }\n}\n\n.timeline_class_indicator {\n  position: absolute;\n  top: -10px;\n  right: -10px;\n  width: 28px;\n  height: 28px;\n  background-size: contain;\n  background-repeat: no-repeat;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.frame-warrior {\n  background-image: url('@assets/HUD/class_icon_frame_w.png');\n}\n\n.frame-black-mage {\n  background-image: url('@assets/HUD/class_icon_frame_bm.png');\n}\n\n.frame-white-mage {\n  background-image: url('@assets/HUD/class_icon_frame_wm.png');\n}\n\n.timeline_class_indicator img {\n  width: 50%;\n  height: 50%;\n  object-fit: contain;\n}\n\n.timeline_class_indicator .warrior {\n  transform: scaleX(1.5);\n}\n\n/* Adjust the portrait container to accommodate the class indicator */\n.timeline_portrait_container {\n  position: relative;\n  margin: 3px;\n}\n\n.ally_portrait {\n  background-image: url('@assets/HUD/blue_box.png');\n}\n\n.enemy_portrait {\n  background-image: url('@assets/HUD/red_box.png');\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
